var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgKoala = function SvgKoala(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#koala_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D32E4",
    d: "M9.59 9.563a.723.723 0 1 0 .003 1.447.723.723 0 0 0-.003-1.447Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D32E4",
    d: "M8 0a8 8 0 0 0-5.657 13.657 7.999 7.999 0 0 0 13.053-8.718 7.999 7.999 0 0 0-1.74-2.596A7.999 7.999 0 0 0 8 0Zm6.35 11.117a1.613 1.613 0 0 0-3.022.791v2.337a7.044 7.044 0 0 1-3.105.833 6.586 6.586 0 0 1-1.666-4.745A6.462 6.462 0 0 1 7.66 7.118a.067.067 0 0 0-.01-.09.072.072 0 0 0-.087.009 5.197 5.197 0 0 0-1.85 3.236 7.989 7.989 0 0 0-.06.414c0 .046-.066.058-.095.05a3.624 3.624 0 1 1 4.06-5.587.375.375 0 0 0 .305.158h4.615a7.065 7.065 0 0 1-.186 5.815l-.002-.006Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "koala_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKoala);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;